import { Routes, Route } from 'react-router-dom';
import { Navigation } from './components';
import {
  HomePage,
  PlanPage,
  LessonPage,
  TrophyRoomPage,
  TrophyDetailPage,
  GamePage,
  AIGeneratorPage,
  SettingsPage,
} from './pages';
import './App.css';

function App() {
  return (
    <div className="app">
      <Navigation />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/plan" element={<PlanPage />} />
          <Route path="/lectie/:id" element={<LessonPage />} />
          <Route path="/trofee" element={<TrophyRoomPage />} />
          <Route path="/trofeu/:id" element={<TrophyDetailPage />} />
          <Route path="/joc" element={<GamePage />} />
          <Route path="/generator" element={<AIGeneratorPage />} />
          <Route path="/setari" element={<SettingsPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
